import {
	useAxiosInstance,
	useDownloadPoMutation,
	verificationDownloadQuery,
} from '@gov-nx/api';
import { useDownloadEvents, useMessageEvents } from '@gov-nx/core/events';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';

export const DownloadVerificationListener = () => {
	const { toastMessageSuccess, toastMessageError } = useMessageEvents();
	const { t } = useLocale(LocalizeNameSpaceTypes.Service);
	const { axiosInstance } = useAxiosInstance();

	const { mutate } = useDownloadPoMutation(verificationDownloadQuery, {
		onSuccess: (props) =>
			download({
				id: props.variables.id,
				...props,
				callback: (id, success, error) => {
					if (success) {
						toastMessageSuccess(
							t('dokument.stazeni-dokumentu-uspech', {
								fileName: props.fileName,
							})
						);
					}
					if (error) {
						toastMessageError();
					}
				},
			}),
	});

	const { download } = useDownloadEvents({
		onVerificationDownload: (_, payload) =>
			mutate(
				{ id: payload.verificationId.toString(), axiosInstance },
				{
					onSuccess: () =>
						payload.callback &&
						payload.callback(payload.verificationId, null, null),
					onError: () =>
						payload.callback &&
						payload.callback(payload.verificationId, null, null),
				}
			),
	});

	return null;
};
